// Google Maps initialization
async function initMap() {
	try {
		// console.log("Map initialization started");
		// Coordinates for Brambanigården, Rådhustorget 5, Sandvika
		const location = { lat: 59.890393, lng: 10.5250345 };

		const mapElement = document.getElementById("map");
		// console.log("Map element:", mapElement);

		if (!mapElement) {
			console.error("Map element not found");
			return;
		}

		const map = new google.maps.Map(mapElement, {
			center: location,
			zoom: 15,
			mapId: "dehn_advokater_map",
		});

		// Create the marker content
		const markerView = new google.maps.marker.PinElement({
			scale: 1.5,
			background: "#c88f42",
			borderColor: "#a76f3e",
			glyphColor: "#f9f4ec",
		});

		// Create the advanced marker
		const marker = new google.maps.marker.AdvancedMarkerElement({
			map,
			position: location,
			title: "Advokatfirmaet Dehn",
			content: markerView.element,
		});

		const infoWindow = new google.maps.InfoWindow({
			content: `
                <div style="padding: 10px;">
                    <h3 style="margin: 0 0 5px 0; font-size: 16px;">Advokatfirmaet Dehn</h3>
                    <p style="margin: 0; font-size: 14px;">Brambanigården<br>Rådhustorget 5<br>1337 Sandvika</p>
                </div>
            `,
		});

		marker.addListener("gmp-click", () => {
			infoWindow.open(map, marker);
		});

		// Open info window by default
		infoWindow.open(map, marker);
	} catch (error) {
		console.error("Error initializing map:", error);
	}
}

// Make initMap globally available
window.initMap = initMap;
